export default __webpack_public_path__ + "static/media/cp_geo_ne.5a508910.svg";